import * as React from 'react';
import classNames from 'classnames';

import './styles.scss';
import { compose } from 'redux';
import withStyles, { WithStyles } from 'react-jss';

export interface ISelectableProps {
    /** Config list */
    options: {
        title: React.ReactNode;
        content: React.ReactNode;
        onClick: (event) => void;
        selected: boolean;
        addOn?: {
            label: React.ReactNode,
            onClick: (event) => void;
        }
    }[];
    /** Buttons */
    buttons: {
        title: React.ReactNode,
        onClick: (event) => void;
    }[];
    /** Label for unselected option */
    labelSelect: React.ReactNode;
    /** Label for selected option */
    labelSelected: React.ReactNode;
}

interface IState {

}

type Props = ISelectableProps & WithStyles<typeof styles>;

/**
 * Basic list element with hover background. You should wrap this inside ListBasic component.
 */
class Selectable extends React.Component<Props, IState> {
    static displayName: string = 'Selectable';

    render () {
        if (this.props.options.length === 0) {
            return null;
        }
        return (
            <ul className={classNames('selectable')}>
                {this.props.options.map((item, index) => {
                    return (
                        <li key={index} className={classNames('selectable-item', this.props.classes.item)}>
                            <button
                                onClick={item.onClick}
                                className={classNames({ active: item.selected })}
                            >
                                <div className="selectable-item-inner">
                                    <div className="selectable-item-title">{item.title}</div>
                                    <div className="selectable-item-content">{item.content}</div>
                                    <div className="selectable-item-marker">{item.selected ? this.props.labelSelected : this.props.labelSelect}</div>
                                    {item.addOn && (
                                        <a className="selectable-item-addon" onClick={item.addOn.onClick}>
                                            {item.addOn.label}
                                        </a>
                                    )}
                                </div>
                            </button>
                        </li>
                    );
                })}
                {this.props.buttons.map((item, index) => {
                    return (
                        <li key={index} className={classNames('selectable-button', this.props.classes.button)}>
                            <button onClick={item.onClick}>
                                <div className="selectable-button-inner">
                                    <div className="selectable-button-title">{item.title}</div>
                                </div>
                            </button>
                        </li>
                    );
                })}
            </ul>
        );
    }
}

const styles = (theme) => {
    return {
        item: {
            '& button': {
                'backgroundColor': theme.colors.gray.lightest,
                '&:before': {
                    borderColor: theme.colors.primary,
                },
                '& .selectable-item-marker': {
                    color: theme.colors.primary,
                },
                '& .selectable-item-addon': {
                    color: theme.colors.primary,
                },
            },
        },
        button: {
            '& button': {
                backgroundColor: theme.colors.gray.light,
            },
        },
    };
};

export default compose<React.ComponentClass<ISelectableProps>>(
    withStyles(styles, { injectTheme: true })
)(Selectable);
